import { ValidationControlBase } from "@frui.ts/bootstrap";
import { bound } from "@frui.ts/helpers";
import type { IBindingProps } from "@frui.ts/views";
import React from "react";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";

export interface LicensePlateInputProps {
  className?: string;
  placeholder?: string;
  countryId?: string;
  disabled?: boolean;
  errorMessage?: string;
  tooltip?: boolean;
  checkFormat?: boolean;
  disableCopy?: boolean;
  disablePaste?: boolean;
  autoComplete?: boolean;
  onBlur?: (e: React.FormEvent<any>) => void;
}

export default class LicensePlateInput<TTarget> extends ValidationControlBase<
  TTarget,
  LicensePlateInputProps & IBindingProps<TTarget>
> {
  @bound
  protected renderInner() {
    const {
      target,
      property,
      className,
      placeholder,
      disabled = false,
      errorMessage,
      disablePaste,
      disableCopy,
      autoComplete,
      onBlur,
    } = this.props;
    const ignoredCharacters = new RegExp(/[^A-Z0-9]+/gi);

    return (
      <AdvancedInput
        trim={true}
        className={className}
        ignoredCharacters={ignoredCharacters}
        transformation={Transformation.UpperCased}
        disabled={disabled}
        target={target}
        property={property}
        autoComplete={autoComplete}
        errorMessage={errorMessage}
        placeholder={placeholder}
        disableCopy={disableCopy}
        disablePaste={disablePaste}
        onBlur={onBlur}
      />
    );
  }
}
